
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/resources/pdpa-compliance-guideline",
      function () {
        return require("private-next-pages/resources/pdpa-compliance-guideline/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/resources/pdpa-compliance-guideline"])
      });
    }
  